export const categories = [
  { id: 'shaonian', name: '少年漫画', slug: 'shaonian' },
  { id: 'shaonv', name: '少女漫画', slug: 'shaonv' },
  { id: 'qingnian', name: '青年漫画', slug: 'qingnian' },
  { id: 'rexue', name: '热血漫画', slug: 'rexue' },
  { id: 'kehuan', name: '科幻漫画', slug: 'kehuan' },
  { id: 'xuanhuan', name: '玄幻漫画', slug: 'xuanhuan' },
  { id: 'kongbu', name: '恐怖漫画', slug: 'kongbu' },
  { id: 'gaoxiao', name: '搞笑漫画', slug: 'gaoxiao' },
  { id: 'yundong', name: '运动漫画', slug: 'yundong' },
  { id: 'lianai', name: '恋爱漫画', slug: 'lianai' },
];

export const mangaList = [
  {
    id: 'jujutsu-kaisen',
    title: '咒术回战',
    cover: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20manga%20cover%20art%20style%2C%20dark%20fantasy%20Japanese%20comic%20illustration%2C%20supernatural%20action%20with%20cursed%20energy%20theme%2C%20minimalist%20clean%20background%2C%20professional%20manga%20cover%20design&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: 'shaonian',
    author: '芥见下下',
    status: '连载中',
    description: '少年虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术师的世界。在这个充满了诅咒与战斗的黑暗奇幻故事中，他将与伙伴们一起对抗强大的咒灵，守护人类的和平。故事紧凑刺激，人物性格鲜明，是不可错过的现象级作品。',
    rating: 9.7,
    views: 12860000,
    updatedAt: '2026-08-03',
    chapterCount: 271,
  },
  {
    id: 'one-piece',
    title: '海贼王',
    cover: 'https://readdy.ai/api/search-image?query=One%20Piece%20manga%20cover%20style%2C%20pirate%20adventure%20Japanese%20comic%20illustration%2C%20straw%20hat%20crew%20theme%2C%20ocean%20voyage%20background%2C%20vibrant%20action%20scene&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: 'shaonian',
    author: '尾田荣一郎',
    status: '连载中',
    description: '蒙奇·D·路飞为了成为海贼王而踏上伟大航路的冒险故事。与伙伴们一起经历了无数艰难险阻，探索未知的岛屿，对抗强大的敌人，追寻传说中的大秘宝ONE PIECE。',
    rating: 9.8,
    views: 35200000,
    updatedAt: '2026-08-03',
    chapterCount: 1120,
  },
  {
    id: 'demon-slayer',
    title: '鬼灭之刃',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Kimetsu%20no%20Yaiba%20manga%20cover%20style%2C%20Japanese%20swordsman%20dark%20fantasy%20illustration%2C%20water%20breathing%20technique%20theme%2C%20traditional%20Japanese%20aesthetic&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: 'shaonian',
    author: '吾峠呼世晴',
    status: '已完结',
    description: '大正时代，少年灶门炭治郎一家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。',
    rating: 9.6,
    views: 18500000,
    updatedAt: '2026-07-28',
    chapterCount: 205,
  },
  {
    id: 'spy-family',
    title: '间谍过家家',
    cover: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20manga%20cover%20style%2C%20comedy%20spy%20Japanese%20comic%20illustration%2C%20family%20slice%20of%20life%20theme%2C%20warm%20playful%20aesthetic%2C%20clean%20background&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: 'gaoxiao',
    author: '远藤达哉',
    status: '连载中',
    description: '为了执行机密任务，顶级间谍"黄昏"组建了一个临时家庭。然而他不知道的是，妻子是一名杀手，女儿是超能力者。这个各怀秘密的家庭开始了爆笑又温馨的日常生活。',
    rating: 9.5,
    views: 9600000,
    updatedAt: '2026-08-02',
    chapterCount: 98,
  },
  {
    id: 'attack-titan',
    title: '进击的巨人',
    cover: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20manga%20cover%20style%2C%20dark%20post%20apocalyptic%20Japanese%20comic%20illustration%2C%20giant%20titan%20theme%2C%20dramatic%20action%20scene%2C%20grim%20atmosphere&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: 'qingnian',
    author: '谏山创',
    status: '已完结',
    description: '人类生活在被巨大城墙围住的城市中，以躲避巨人的捕食。少年艾伦·耶格尔在目睹母亲被巨人吃掉后，发誓要消灭所有巨人，加入了调查兵团，逐渐揭开了世界的真相。',
    rating: 9.7,
    views: 22100000,
    updatedAt: '2026-06-15',
    chapterCount: 139,
  },
  {
    id: 'chainsaw-man',
    title: '电锯人',
    cover: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20manga%20cover%20style%2C%20dark%20gritty%20Japanese%20comic%20illustration%2C%20devil%20hunter%20theme%2C%20blood%20red%20accent%2C%20urban%20horror%20aesthetic&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: 'shaonian',
    author: '藤本树',
    status: '连载中',
    description: '为了偿还亡父的债务，少年淀治与恶魔波奇塔一起作为恶魔猎人工作。在一次背叛中被杀害后，波奇塔与他合体，使他重生为拥有链锯能力的"电锯人"。',
    rating: 9.3,
    views: 7800000,
    updatedAt: '2026-08-01',
    chapterCount: 167,
  },
  {
    id: 'jjk-0',
    title: '咒术回战0',
    cover: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%200%20manga%20cover%20style%2C%20Yuta%20Okkotsu%20dark%20fantasy%20illustration%2C%20cursed%20spirit%20theme%2C%20Japanese%20supernatural%20aesthetic%2C%20clean%20dramatic%20composition&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: 'shaonian',
    author: '芥见下下',
    status: '已完结',
    description: '咒术回战的前传故事。高中生乙骨忧太被青梅竹马祈本里香的怨灵附身，在五条悟的引导下进入东京都立咒术高等专门学校，学习控制诅咒之力的故事。',
    rating: 9.5,
    views: 5200000,
    updatedAt: '2026-05-20',
    chapterCount: 4,
  },
  {
    id: 'hunter-hunter',
    title: '全职猎人',
    cover: 'https://readdy.ai/api/search-image?query=Hunter%20x%20Hunter%20manga%20cover%20style%2C%20adventure%20fantasy%20Japanese%20comic%20illustration%2C%20hunter%20exam%20theme%2C%20dynamic%20action%20pose%2C%20clean%20background&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: 'shaonian',
    author: '富坚义博',
    status: '连载中',
    description: '少年小杰为了寻找父亲而参加猎人考试，成为一名职业猎人。在这个过程中他结识了奇犽、酷拉皮卡和雷欧力等好友，一起踏上了充满危险与奇遇的冒险之旅。',
    rating: 9.7,
    views: 15600000,
    updatedAt: '2026-07-15',
    chapterCount: 400,
  },
  {
    id: 'tokyo-revengers',
    title: '东京复仇者',
    cover: 'https://readdy.ai/api/search-image?query=Tokyo%20Revengers%20manga%20cover%20style%2C%20delinquent%20gang%20Japanese%20comic%20illustration%2C%20time%20travel%20theme%2C%20urban%20street%20aesthetic%2C%20dramatic%20character%20design&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: 'shaonian',
    author: '和久井健',
    status: '已完结',
    description: '落魄青年花垣武道得知前女友被黑帮杀害，意外获得穿越能力回到中学时代。他决心改变过去，拯救心爱之人，逐步卷入了东京黑帮世界的纷争之中。',
    rating: 9.2,
    views: 8900000,
    updatedAt: '2026-04-10',
    chapterCount: 278,
  },
  {
    id: 'frieren',
    title: '葬送的芙莉莲',
    cover: 'https://readdy.ai/api/search-image?query=Frieren%20Beyond%20Journey%20End%20manga%20cover%20style%2C%20Japanese%20fantasy%20comic%20illustration%2C%20elf%20mage%20theme%2C%20peaceful%20melancholic%20aesthetic%2C%20soft%20atmospheric%20background&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: 'shaonian',
    author: '山田钟人',
    status: '连载中',
    description: '打败魔王的勇者队伍中的精灵魔法使芙莉莲，在同伴相继离世后，开始了理解人类情感与生命意义的旅程。一部关于时间、回忆与羁绊的温暖奇幻故事。',
    rating: 9.8,
    views: 7200000,
    updatedAt: '2026-08-02',
    chapterCount: 132,
  },
  {
    id: 'blue-lock',
    title: '蓝色监狱',
    cover: 'https://readdy.ai/api/search-image?query=Blue%20Lock%20manga%20cover%20style%2C%20soccer%20sports%20Japanese%20comic%20illustration%2C%20intense%20competition%20theme%2C%20dynamic%20football%20action%2C%20clean%20athletic%20aesthetic&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: 'yundong',
    author: '金城宗幸',
    status: '连载中',
    description: '为了培养世界第一的前锋，日本足球协会启动了"蓝色监狱"计划。300名高中前锋被关进封闭设施，在残酷的淘汰赛中争夺唯一的生存名额。',
    rating: 9.4,
    views: 6500000,
    updatedAt: '2026-08-03',
    chapterCount: 258,
  },
  {
    id: 'my-hero-academia',
    title: '我的英雄学院',
    cover: 'https://readdy.ai/api/search-image?query=My%20Hero%20Academia%20manga%20cover%20style%2C%20superhero%20Japanese%20comic%20illustration%2C%20hero%20academy%20theme%2C%20bright%20action%20aesthetic%2C%20clean%20dynamic%20design&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: 'shaonian',
    author: '堀越耕平',
    status: '连载中',
    description: '在一个人人都拥有超能力"个性"的世界里，天生无个性的少年绿谷出久梦想成为最伟大的英雄。在偶遇No.1英雄欧尔麦特后，他继承了个性"One For All"，踏上了英雄之路。',
    rating: 9.3,
    views: 11200000,
    updatedAt: '2026-08-01',
    chapterCount: 420,
  },
];

export const rankingData = [
  { rank: 1, mangaId: 'one-piece', title: '海贼王', views: 35200000, trend: 'up' },
  { rank: 2, mangaId: 'attack-titan', title: '进击的巨人', views: 22100000, trend: 'stable' },
  { rank: 3, mangaId: 'demon-slayer', title: '鬼灭之刃', views: 18500000, trend: 'stable' },
  { rank: 4, mangaId: 'hunter-hunter', title: '全职猎人', views: 15600000, trend: 'up' },
  { rank: 5, mangaId: 'jujutsu-kaisen', title: '咒术回战', views: 12860000, trend: 'up' },
  { rank: 6, mangaId: 'my-hero-academia', title: '我的英雄学院', views: 11200000, trend: 'down' },
  { rank: 7, mangaId: 'spy-family', title: '间谍过家家', views: 9600000, trend: 'up' },
  { rank: 8, mangaId: 'tokyo-revengers', title: '东京复仇者', views: 8900000, trend: 'stable' },
  { rank: 9, mangaId: 'chainsaw-man', title: '电锯人', views: 7800000, trend: 'up' },
  { rank: 10, mangaId: 'frieren', title: '葬送的芙莉莲', views: 7200000, trend: 'down' },
];

export const chapterData: Record<string, { id: string; title: string; pageCount: number; updatedAt: string }[]> = {
  'jujutsu-kaisen': [
    { id: 'jjk-ch271', title: '第271话 最终的抉择', pageCount: 21, updatedAt: '2026-08-03' },
    { id: 'jjk-ch270', title: '第270话 宿傩的真相', pageCount: 19, updatedAt: '2026-07-27' },
    { id: 'jjk-ch269', title: '第269话 五条的决心', pageCount: 22, updatedAt: '2026-07-20' },
    { id: 'jjk-ch268', title: '第268话 虎杖的觉醒', pageCount: 20, updatedAt: '2026-07-13' },
    { id: 'jjk-ch267', title: '第267话 咒术高专集结', pageCount: 18, updatedAt: '2026-07-06' },
    { id: 'jjk-ch266', title: '第266话 领域展开', pageCount: 23, updatedAt: '2026-06-29' },
    { id: 'jjk-ch265', title: '第265话 黑闪连击', pageCount: 19, updatedAt: '2026-06-22' },
    { id: 'jjk-ch264', title: '第264话 反转术式', pageCount: 20, updatedAt: '2026-06-15' },
    { id: 'jjk-ch263', title: '第263话 不义游戏', pageCount: 21, updatedAt: '2026-06-08' },
    { id: 'jjk-ch262', title: '第262话 死灭回游', pageCount: 22, updatedAt: '2026-06-01' },
  ],
  'one-piece': [
    { id: 'op-ch1120', title: '第1120话 最终的岛屿', pageCount: 19, updatedAt: '2026-08-03' },
    { id: 'op-ch1119', title: '第1119话 路飞的决意', pageCount: 20, updatedAt: '2026-07-27' },
    { id: 'op-ch1118', title: '第1118话 四皇集结', pageCount: 21, updatedAt: '2026-07-20' },
    { id: 'op-ch1117', title: '第1117话 历史正文', pageCount: 18, updatedAt: '2026-07-13' },
    { id: 'op-ch1116', title: '第1116话 古代兵器', pageCount: 22, updatedAt: '2026-07-06' },
  ],
  'demon-slayer': [
    { id: 'ds-ch205', title: '第205话 黎明的到来（最终话）', pageCount: 28, updatedAt: '2026-07-28' },
    { id: 'ds-ch204', title: '第204话 鬼舞辻无惨', pageCount: 22, updatedAt: '2026-07-21' },
    { id: 'ds-ch203', title: '第203话 赫刀', pageCount: 20, updatedAt: '2026-07-14' },
  ],
  'spy-family': [
    { id: 'sf-ch98', title: '第98话 家庭旅行', pageCount: 18, updatedAt: '2026-08-02' },
    { id: 'sf-ch97', title: '第97话 安妮亚的考试', pageCount: 20, updatedAt: '2026-07-26' },
    { id: 'sf-ch96', title: '第96话 约尔的秘密', pageCount: 19, updatedAt: '2026-07-19' },
  ],
  'attack-titan': [
    { id: 'aot-ch139', title: '第139话 朝向山丘上的那棵树（最终话）', pageCount: 26, updatedAt: '2026-06-15' },
    { id: 'aot-ch138', title: '第138话 漫长的梦', pageCount: 24, updatedAt: '2026-06-08' },
    { id: 'aot-ch137', title: '第137话 巨人', pageCount: 23, updatedAt: '2026-06-01' },
  ],
  'chainsaw-man': [
    { id: 'csm-ch167', title: '第167话 黑锯', pageCount: 21, updatedAt: '2026-08-01' },
    { id: 'csm-ch166', title: '第166话 战争恶魔', pageCount: 19, updatedAt: '2026-07-25' },
    { id: 'csm-ch165', title: '第165话 那由多', pageCount: 20, updatedAt: '2026-07-18' },
  ],
};

export const articleContent: Record<string, { title: string; content: string; prevChapter?: string; nextChapter?: string }> = {
  'jjk-ch271': {
    title: '第271话 最终的抉择',
    content: '在经历了漫长而激烈的战斗之后，虎杖悠仁终于面对着自己内心深处最大的恐惧。宿傩的力量在他体内涌动，那股诅咒之力仿佛要将他的灵魂撕裂。\n\n"这就是我的选择。"虎杖咬紧牙关，他的眼神中透露出前所未有的坚定。伏黑惠站在他的身后，十种影法术已经准备就绪。钉崎野蔷薇紧握着手中的锤子，咒力在她周身流转。\n\n五条悟的身影从天而降，他的六眼闪烁着冰冷的光芒。"准备好了吗，各位？"他的声音中带着一丝不易察觉的笑意。\n\n宿傩的诅咒之力如同黑色的潮水般涌来，整个涩谷的天空都被染成了暗红色。虎杖深吸一口气，他能感受到体内的每一根血管都在沸腾。\n\n"领域展开——"宿傩的声音如同从地狱深处传来，"伏魔御厨子！"\n\n在那一瞬间，整个世界仿佛都静止了。虎杖看到了——那是他必须战胜的宿命。',
    prevChapter: 'jjk-ch270',
    nextChapter: undefined,
  },
  'jjk-ch270': {
    title: '第270话 宿傩的真相',
    content: '五条悟站在废墟之上，他的白色头发在风中凌乱。眼前的宿傩已经完全恢复了力量，那股压倒性的诅咒气息让周围的空气都变得沉重。\n\n"真是令人怀念的感觉啊。"宿傩咧嘴笑了，四只眼睛中闪烁着疯狂的光芒。"五条悟，你还记得上一次交手的时候吗？"\n\n五条没有回答，他的六眼正在全力运转，分析着宿傩的每一个细微动作。他知道，面对完全体的宿傩，任何一丝大意都可能导致毁灭性的后果。\n\n"你们这些咒术师啊，"宿傩缓缓抬起手，"总是以为自己能够掌控一切。但是你们忘记了，诅咒本身就是人类最原始的恐惧。"\n\n虎杖在远处艰难地爬起来，他听到了宿傩的话。作为宿傩的容器，他比任何人都更了解这股黑暗力量的本质。\n\n"但是，"虎杖握紧了拳头，"正是因为了解，所以我绝不会让你为所欲为！"',
    prevChapter: 'jjk-ch269',
    nextChapter: 'jjk-ch271',
  },
  'jjk-ch269': {
    title: '第269话 五条的决心',
    content: '深夜的咒术高专，月光洒落在空无一人的训练场上。五条悟独自站在那里，他的目光望向远方，仿佛穿透了时空的界限。\n\n"已经过去这么多年了啊。"他轻声自语，眼罩下的六眼微微发光。从夏油杰离开的那一天起，他就发誓要改变这个扭曲的咒术世界。\n\n虎杖、伏黑、钉崎——这些年轻的面孔浮现在他的脑海中。他们都是他亲自挑选的学生，也是他寄予厚望的新一代咒术师。\n\n"这一次，我绝不会让任何人牺牲。"五条取下眼罩，那双如同天空般湛蓝的眼睛中闪烁着坚定的光芒。他知道即将到来的战斗将是最为惨烈的一次，但他已经做好了准备。\n\n为了学生们，为了这个世界的未来，他愿意付出一切。',
    prevChapter: 'jjk-ch268',
    nextChapter: 'jjk-ch270',
  },
};

export const testimonials = [
  {
    id: 1,
    name: '漫画爱好者小王',
    avatar: '',
    rating: 5,
    content: '36漫画网真的太棒了！咒术回战全集无删减，而且完全免费。更新速度也很快，每周都在追。画质清晰，阅读体验一流，强烈推荐！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '资深漫迷老李',
    avatar: '',
    rating: 5,
    content: '作为一个看了十几年漫画的老读者，36漫画网的阅读体验确实没得说。无广告骚扰，加载速度快，章节齐全。咒术回战的翻译质量也很高。',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '学生党小明',
    avatar: '',
    rating: 5,
    content: '终于找到一个可以免费看咒术回战全集的地方了！之前在其他网站总是缺章少节，36漫画网真的很良心，推荐给所有喜欢看漫画的朋友！',
    date: '2026-07-20',
  },
  {
    id: 4,
    name: '二次元少女',
    avatar: '',
    rating: 4,
    content: '界面设计很简洁好看，分类也很清晰。不只是咒术回战，其他漫画资源也很丰富。希望能增加更多的少女漫画作品！',
    date: '2026-07-18',
  },
  {
    id: 5,
    name: '上班族阿杰',
    avatar: '',
    rating: 5,
    content: '通勤路上用手机看漫画，36漫画网的移动端适配做得很好。咒术回战的最新话总是第一时间更新，追更党的福音！',
    date: '2026-07-15',
  },
  {
    id: 6,
    name: '漫画教师张老师',
    avatar: '',
    rating: 5,
    content: '作为一名美术老师，我很看重画质的还原度。36漫画网的图片质量非常高，细节清晰，用来做教学参考也很不错。咒术回战的画风真的太赞了。',
    date: '2026-07-10',
  },
];